import { hcpSpecialties } from '../../../constants';

const findSpecialityLabel = (category: string) => {
  const found = hcpSpecialties.find(it => it.value === category);
  return found ? found.label : '';
};

export { findSpecialityLabel };
